/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AutoTranslateLanguageRequest,
  CreateLanguageRequest,
  GetLanguageTranslations200Response,
  GetLanguages200ResponseInner,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  SetDefaultLanguageRequest,
  TranslateItemRequest,
  UpdateLocationComboRequest,
} from '../models/index';
import {
    AutoTranslateLanguageRequestFromJSON,
    AutoTranslateLanguageRequestToJSON,
    CreateLanguageRequestFromJSON,
    CreateLanguageRequestToJSON,
    GetLanguageTranslations200ResponseFromJSON,
    GetLanguageTranslations200ResponseToJSON,
    GetLanguages200ResponseInnerFromJSON,
    GetLanguages200ResponseInnerToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    SetDefaultLanguageRequestFromJSON,
    SetDefaultLanguageRequestToJSON,
    TranslateItemRequestFromJSON,
    TranslateItemRequestToJSON,
    UpdateLocationComboRequestFromJSON,
    UpdateLocationComboRequestToJSON,
} from '../models/index';

export interface AutoTranslateLanguageOperationRequest {
    language: string;
    autoTranslateLanguageRequest: AutoTranslateLanguageRequest;
}

export interface CreateLanguageOperationRequest {
    createLanguageRequest: CreateLanguageRequest;
}

export interface EnableLanguageRequest {
    language: string;
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface GetLanguageTranslationsRequest {
    language: string;
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
    from?: string;
}

export interface SetDefaultLanguageOperationRequest {
    setDefaultLanguageRequest: SetDefaultLanguageRequest;
}

export interface TranslateItemOperationRequest {
    language: string;
    organizationItemId: string;
    translateItemRequest?: TranslateItemRequest;
}

/**
 * 
 */
export class TranslationsCatalogApi extends runtime.BaseAPI {

    /**
     */
    async autoTranslateLanguageRaw(requestParameters: AutoTranslateLanguageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling autoTranslateLanguage().'
            );
        }

        if (requestParameters['autoTranslateLanguageRequest'] == null) {
            throw new runtime.RequiredError(
                'autoTranslateLanguageRequest',
                'Required parameter "autoTranslateLanguageRequest" was null or undefined when calling autoTranslateLanguage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/translations/{language}/translations/auto-translate`.replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutoTranslateLanguageRequestToJSON(requestParameters['autoTranslateLanguageRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async autoTranslateLanguage(requestParameters: AutoTranslateLanguageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.autoTranslateLanguageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createLanguageRaw(requestParameters: CreateLanguageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createLanguageRequest'] == null) {
            throw new runtime.RequiredError(
                'createLanguageRequest',
                'Required parameter "createLanguageRequest" was null or undefined when calling createLanguage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/translations/language`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLanguageRequestToJSON(requestParameters['createLanguageRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createLanguage(requestParameters: CreateLanguageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createLanguageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async enableLanguageRaw(requestParameters: EnableLanguageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling enableLanguage().'
            );
        }

        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling enableLanguage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/translations/{language}/enable`.replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableLanguage(requestParameters: EnableLanguageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableLanguageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getLanguageTranslationsRaw(requestParameters: GetLanguageTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLanguageTranslations200Response>> {
        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling getLanguageTranslations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/translations/{language}/translations`.replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLanguageTranslations200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLanguageTranslations(requestParameters: GetLanguageTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLanguageTranslations200Response> {
        const response = await this.getLanguageTranslationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLanguagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLanguages200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/translations/languages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLanguages200ResponseInnerFromJSON));
    }

    /**
     */
    async getLanguages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLanguages200ResponseInner>> {
        const response = await this.getLanguagesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async setDefaultLanguageRaw(requestParameters: SetDefaultLanguageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['setDefaultLanguageRequest'] == null) {
            throw new runtime.RequiredError(
                'setDefaultLanguageRequest',
                'Required parameter "setDefaultLanguageRequest" was null or undefined when calling setDefaultLanguage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/translations/default-language`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetDefaultLanguageRequestToJSON(requestParameters['setDefaultLanguageRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setDefaultLanguage(requestParameters: SetDefaultLanguageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultLanguageRaw(requestParameters, initOverrides);
    }

    /**
     */
    async translateItemRaw(requestParameters: TranslateItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling translateItem().'
            );
        }

        if (requestParameters['organizationItemId'] == null) {
            throw new runtime.RequiredError(
                'organizationItemId',
                'Required parameter "organizationItemId" was null or undefined when calling translateItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/translations/{language}/translations/{organizationItemId}`.replace(`{${"language"}}`, encodeURIComponent(String(requestParameters['language']))).replace(`{${"organizationItemId"}}`, encodeURIComponent(String(requestParameters['organizationItemId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TranslateItemRequestToJSON(requestParameters['translateItemRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async translateItem(requestParameters: TranslateItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.translateItemRaw(requestParameters, initOverrides);
    }

}
